import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from "moment";
import axios from 'axios';

import Layout from '../components/Layout';
import Toparea from '../components/Toparea';

import { Link } from 'react-router-dom';
import '../assets/scss/main.scss'
import '../assets/scss/v1plus.scss'

const CheckCalendar = (props) => {
	const [value] = useState(new Date());
	const [dayList, setDayList] = useState([]);
	const [stats, setStats] = useState(null); // streak, learned words, XP from /api/learn/stats

	useEffect(() => {
		axios.get('/api/attendance')
			.then(response => setDayList(response.data))
			.catch(error => console.error('Fetch attendance failed', error));
		axios.get('/api/learn/stats')
			.then(response => setStats(response.data))
			.catch(error => console.error('Fetch stats failed', error));
	}, []);

	// 각 날짜 타일에 컨텐츠 추가
	const addContent = ({ date, view }) => {
		// view가 'month'일 때만 표시
		if (view !== 'month') return null;

		const dateStr = moment(date).format('YYYY-MM-DD');
		if (dayList.includes(dateStr)) {
			return (
				<div>
					<i className="icon-check">
						<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 6L5.5 10.5L19 1" stroke="white" strokeLinecap="round" />
						</svg>
					</i>
				</div>
			);
		}
		return null;
	};

	return (
		<Layout containName='calendar'>
			<Toparea />

			<div className="box-wrap">
				<div className="box-line">
					<div className="box calendar">
						<p className="v1-keep">{stats ? `DAY ${stats.day} · 🔥${stats.streak}일` : '출석체크'}</p>
						<strong><span>{dayList.length}</span>일차</strong>
					</div>
				</div>
			</div>
			{stats && (
				<div className="v1-stats" style={{ margin: '10px 20px 40px' }}>
					<div><b>{stats.streak}일</b><small>연속 학습</small></div>
					<div><b>{stats.learned}</b><small>배운 단어</small></div>
					<div><b>{stats.xp}</b><small>XP</small></div>
				</div>
			)}
			<Calendar
				calendarType="gregory"
				value={value}
				// disabled={true} 
				formatMonthYear={(locale, date) => moment(date).format("YYYY. MM")}
				formatDay={(locale, date) => moment(date).format("D")}
				tileContent={addContent}
				showNeighboringMonth={false}
				next2Label={null}
				prev2Label={null}
				minDetail="year"
			></Calendar>

			<Link to="/Challenge/Result" className="v1-records-link">챌린지 시험 결과 보기 ›</Link>
			<Link to="/Main" className="v1-records-link" style={{ marginTop: 0 }}>메인으로 ›</Link>

		</Layout>
	);
};

export default CheckCalendar;